import { API_BASE_URL } from "configs/AppConfig";
export const url = API_BASE_URL;
const configration = {
  APIURL: url,
};
export default configration;
